import { makeStyles } from 'tss-react/mui';

const useStylesPageTabs: MaterialUIStylesCallback = makeStyles()((theme: MainTheme): MaterialUIStyles => ({
  pageTabs: {
    width: '100%',
    borderTop: `1px solid ${theme.palette.info.main}`,
  },
  containerPageTabsResponsive: {
    '& div:first-of-type:empty': {
      display: 'none',
    },
  },
  containerPageTabsResponsiveState1: {
    maxWidth: 230,
  },
  containerPageTabsResponsiveState2: {
    maxWidth: 400,
  },
  containerPageTabsResponsiveState3: {
    maxWidth: 220,
  },
  containerPageTabsResponsiveState4: {
    maxWidth: 370,
  },
  containerPageTabsResponsiveState5: {
    maxWidth: 450,
  },
  containerPageTabsResponsiveState6: {
    maxWidth: 500,
  },
  containerPageTabsResponsiveState7: {
    maxWidth: 550,
  },
  pageTabsContent: {
    marginTop: 1,
  },
  pageTabsTabs: {
    width: 'auto',
    backgroundColor: theme.palette.background.default,
    '& > .Mui-disabled': {
      opacity: '0.1 !important',
    },
  },
  pageTabsTab: {
    minWidth: '100px !important',
    maxWidth: '200px !important',
    width: '100%',
    height: '25px !important',
    '&:hover': {
      backgroundColor: `${theme.palette.primary.light} !important`,
    },
  },
  pageTabsTabDeletable: {
    '& > span': {
      '&:first-of-type': {
        color: theme.palette.action.disabled,
        width: '10%',
        position: 'absolute',
        right: 10,
        top: 15,
      },
      '&:last-of-type': {
        width: '90%',
      },
    },
  },
  pageTabsTabDeletableResponsive: {
    '& > span': {
      '&:first-of-type': {
        top: 13,
        right: 5,
        width: 'auto',
      },
      '&:last-of-type': {
        width: 'auto',
      },
    },
  },
  pageTabsTabHidden: {
    display: 'none !important',
  },
  pageTabsTabIcon: {
    minHeight: '48px !important',
  },
  pageTabsTabIconResponsive: {
    minWidth: '150px !important',
  },
  pageTabsTabDisabled: {
    color: `${theme.palette.action.disabled} !important`,
    cursor: 'default !important',
    '&:hover': {
      backgroundColor: 'transparent !important',
    },
  },
  pageTabsTabActive: {
    color: `${theme.palette.common.black} !important`,
    backgroundColor: `${theme.palette.info.light} !important`,
  },
  pageTabsLoader: {
    height: 'calc(100vh - 260px)',
  },
}));

export default useStylesPageTabs;
